export const WEBHOOK_API = 'https://webhook.site/1bfcb918-c2ca-4745-b0d5-ea40c4b58f8b';